import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconArrowLeft: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;
  return (
    <Icon {...props}>
      <path
        d="M15.422 16.594l-1.406 1.406-6-6 6-6 1.406 1.406-4.594 4.594z"
        fill={fill}
      />
    </Icon>
  );
};

export default IconArrowLeft;
